export default "/images/6bf84daaac674b06ee4f36e9be645d89.avif";